import { render } from "./ManageServices.vue?vue&type=template&id=1729e6b4&scoped=true"
import script from "./ManageServices.vue?vue&type=script&lang=js"
export * from "./ManageServices.vue?vue&type=script&lang=js"

import "./ManageServices.vue?vue&type=style&index=0&id=1729e6b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1729e6b4"]])

export default __exports__